/**
 * DOM utils
 */

const getWindow = (node?: any): Window & typeof globalThis =>
  node?.ownerDocument?.defaultView ?? window

const isWindow = (node: unknown): node is Window => node === getWindow(node)

const getDocument = (node?: any): HTMLDocument =>
  node?.ownerDocument ?? document

const getNodeName = (node: Node) => node.nodeName.toLowerCase()

const isDocument = (node: Node): node is Document =>
  getNodeName(node) === "#document"

const isElement = (node: Node): node is HTMLElement =>
  node instanceof getWindow(node).HTMLElement

const isHtmlElement = (node: Node | null): node is HTMLHtmlElement =>
  node !== null && getNodeName(node) === "html"

const isBodyElement = (node: Node): node is HTMLBodyElement =>
  getNodeName(node) === "body"

const isRoot = (node: Node) =>
  isBodyElement(node) || isHtmlElement(node) || isDocument(node)

const hasOverflow = (element: Element) => {
  const { overflow, overflowX, overflowY } = getWindow(
    element
  ).getComputedStyle(element, null)

  return /auto|scroll|overlay|hidden/.test(overflow + overflowX + overflowY)
}

const getParentNode = (node: Node): Node =>
  isHtmlElement(node)
    ? node
    : node.parentNode || node.ownerDocument || document.documentElement

export {
  isBodyElement,
  isDocument,
  isElement,
  isHtmlElement,
  isRoot,
  isWindow,
  getDocument,
  getParentNode,
  getWindow,
  hasOverflow
}
